import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AxelCard"] */ "/app/src/components/site/AxelCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpenAssistantButton"] */ "/app/src/components/site/OpenAssistantButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageEyebrow"] */ "/app/src/components/site/PageEyebrow.tsx");
